module.exports = __webpack_public_path__ + "static/media/ny-yogi.c1cc380b.jpg";